/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { menuManagerItemDtoSchema } from './menuManagerItemDtoSchema.ts';
import { z } from 'zod';

/**
 * @description OK
 */
export const putApiMenuManager200Schema = z.array(
  z.lazy(() => menuManagerItemDtoSchema),
);

export const putApiMenuManagerMutationRequestSchema = z.array(
  z.lazy(() => menuManagerItemDtoSchema),
);

export const putApiMenuManagerMutationResponseSchema = z.lazy(
  () => putApiMenuManager200Schema,
);
